import gql from "graphql-tag";

export const GET_AGREEMENTS = gql`
    query GetAgreements($filter: AgreementFilterInput) {
        agreements(filter: $filter) {
            _id
            attachments {
                fileId
                clientId
                fileName
                mimeType
                mD5
                updateTimestamp
            }
            client {
                _id
                name
            }
            clientId
            counterParties {
                _id
                name
            }
            counterPartyIds
            createTimestamp
            description
            parties {
                _id
                name
            }
            partyIds
            status
            type
            approvedInfo {
                status
                comment
                updateUserId
                updateUserInfo {
                    name
                }
                updateTimestamp
            }
            updateTimestamp
            updateUserId
            updateUserInfo {
                name
            }
            attachments {
                fileId
            }
        }
    }
`;

export const UPSERT_AGREEMENTS = gql`
    mutation UpsertAgreements($input: [AgreementInput!]!) {
        upsertAgreements(input: $input) {
            _id
            attachments {
                fileId
                clientId
                fileName
                mimeType
                mD5
                updateTimestamp
            }
            client {
                _id
                name
            }
            clientId
            counterParties {
                _id
                name
            }
            counterPartyIds
            createTimestamp
            description
            parties {
                _id
                name
            }
            partyIds
            status
            type
            approvedInfo {
                status
                comment
                updateUserId
                updateUserInfo {
                    name
                }
                updateTimestamp
            }
            updateTimestamp
            updateUserId
            updateUserInfo {
                name
            }
            versions
        }
    }
`;

export const GET_AGREEMENT_PARTIES = gql`
    query GetParties {
        clients: parties(filter: { typeIn: [Client] }) {
            _id
            name
        }

        parties(filter: { typeIn: [Client, Broker, ClearingBroker, Custodian, ClearingHouse, EsgDataProvider] }) {
            _id
            name
        }
    }
`;
